import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { UserLoginData, UserLogoutReducer } from "./Redux/Reducers/AuthReducer";
import {
  OrganizationListData,
  SupportRequestListData,
  UpdateSupportRequestStatus,
  NewsLettertListData,
  MeetingSlotData,
  CreateMeetingSlotData,
  SaleInquiriesListData,
  UpdateDemoStatusData,
  OrganizationDetailsData,
  OrganizationPaymentDetailsData,
  ActivateEvalPromoData,
  UsersListData,
  DeactivateOrganizationData,
  DeactivateBrewUserData,
  OrgMembersListData,
  AssignAccountManagerData,
  CreateOrganizationData,
  RemoveAccountManagerData,
  OrgPricingData,
  OrgPricingHistoryData,
  OrgPricingMutationData,
} from "./Redux/Reducers/OrganizationReducer";
import { ContestListData } from "./Redux/Reducers/Contest";
import {
  CouponCreateReducer,
  CouponListReducer,
  CouponUsageListReducer,
  DLQMessagesListReducer,
  FetchPlanDetailReducer,
  PaymentPlanCreateReducer,
  PaymentPlanListReducer,
  PlanDiscountCreateReducer,
  PlanDiscountUpdateReducer,
  ManualCreditGrantReducer,
  PromoCodeCreateReducer,
  PromoCodeListReducer,
  PromoUsageListReducer,
  ServiceChargeCreateReducer,
  ServiceChargeListReducer,
  UpdateCouponReducer,
  UpdatePlanReducer,
  UpdatePromoReducer,
  EntityTransactionsReducer,
} from "./Redux/Reducers/PaymentReducer";
import {
  JobApplicantsListReducer,
  JobCreateReducer,
  JobDetailReducer,
  JobListReducer,
  SkillsListReducer,
} from "./Redux/Reducers/CareerReducer";
import {
  DeleteFileReducer,
  GetPresignedUrlReducer,
  UploadFileReducer,
} from "./Redux/Reducers/S3UploadReducer";
import {
  BadgeCreateReducer,
  BadgeDeleteReducer,
  BadgeListReducer,
  BadgeUpdateReducer,
  CertificateCreateReducer,
  CertificateCriteriaByIdReducer,
  CertificateCriteriaCreateReducer,
  CertificateCriteriaDeleteReducer,
  CertificateCriteriaListReducer,
  CertificateCriteriaUpdateReducer,
  CertificateDeleteReducer,
  CertificateListReducer,
  CertificateTemplateUploadReducer,
  CertificateUpdateReducer,
} from "./Redux/Reducers/RewardReducer";
import {
  QuestionDetailsReducer,
  QuestionListReducer,
  QuestionVerifyReducer,
  ExtractQuestionPdfReducer,
  BulkCreateMCQReducer,
} from "./Redux/Reducers/QuestionVerifyReducer";
import {
  SkillsAdminListReducer,
  SkillsBulkVerifyReducer,
  SkillsCsvUploadReducer,
  SkillsManualUploadReducer,
} from "./Redux/Reducers/SkillReducer";
import {
  CmsPageCreateReducer,
  CmsPageDetailReducer,
  CmsPageListReducer,
} from "./Redux/Reducers/CmsReducer";
import {
  FeatureCatalogListReducer,
  FeatureCatalogMutationReducer,
  CalculatorPresetListReducer,
  CalculatorPresetMutationReducer,
  TopupPresetListReducer,
  TopupPresetMutationReducer,
  TopupBonusRuleListReducer,
  TopupBonusRuleMutationReducer,
  CurrencyCreditRateListReducer,
  CurrencyCreditRateMutationReducer,
  ChargeSyncPreviewReducer,
  ChargeSyncApplyReducer,
} from "./Redux/Reducers/PricingReducer";

const reducer = combineReducers({
  UserLoginDataState: UserLoginData,
  UserLogoutState: UserLogoutReducer,
  OrganizationListData: OrganizationListData,
  ContestListData: ContestListData,
  SupportRequestListData: SupportRequestListData,
  UpdateSupportRequestStatus: UpdateSupportRequestStatus,
  NewsLettertListData: NewsLettertListData,
  MeetingSlotData: MeetingSlotData,
  CreateMeetingSlotData: CreateMeetingSlotData,
  SaleInquiriesListData: SaleInquiriesListData,
  UpdateDemoStatusData: UpdateDemoStatusData,
  OrganizationDetailsData: OrganizationDetailsData,
  OrganizationPaymentDetailsData: OrganizationPaymentDetailsData,
  ActivateEvalPromoData: ActivateEvalPromoData,
  DeactivateOrganizationData: DeactivateOrganizationData,
  DeactivateBrewUserData: DeactivateBrewUserData,
  OrgMembersListData: OrgMembersListData,
  AssignAccountManagerData: AssignAccountManagerData,
  CreateOrganizationData: CreateOrganizationData,
  RemoveAccountManagerData: RemoveAccountManagerData,
  OrgPricingData: OrgPricingData,
  OrgPricingHistoryData: OrgPricingHistoryData,
  OrgPricingMutationData: OrgPricingMutationData,
  UsersListData: UsersListData,
  PaymentPlansListData: PaymentPlanListReducer,
  CreatePaymentPlanData: PaymentPlanCreateReducer,
  PromoCodeListData: PromoCodeListReducer,
  PromoUsageListData: PromoUsageListReducer,
  UpdatePromoResponse: UpdatePromoReducer,
  CreatePromoCodeData: PromoCodeCreateReducer,
  ServiceChargeListData: ServiceChargeListReducer,
  CreateServiceChargeData: ServiceChargeCreateReducer,
  DLQMessagesListData: DLQMessagesListReducer,
  JobListData: JobListReducer,
  JobCreateData: JobCreateReducer,
  SkillListData: SkillsListReducer,
  JobDetailData: JobDetailReducer,
  JobApplicantsListData: JobApplicantsListReducer,
  SkillsAdminListData: SkillsAdminListReducer,
  SkillsManualUploadData: SkillsManualUploadReducer,
  SkillsCsvUploadData: SkillsCsvUploadReducer,
  SkillsBulkVerifyData: SkillsBulkVerifyReducer,

  CmsPageListData: CmsPageListReducer,
  CmsPageDetailData: CmsPageDetailReducer,
  CmsPageCreateData: CmsPageCreateReducer,

  CouponListData: CouponListReducer,
  CouponUsageListData: CouponUsageListReducer,
  UpdateCouponResponse: UpdateCouponReducer,
  CreateCouponResponse: CouponCreateReducer,
  GetPlanDetailData: FetchPlanDetailReducer,
  UpdatePlanResponse: UpdatePlanReducer,
  PlanDiscountCreateResponse: PlanDiscountCreateReducer,
  PlanDiscountUpdateResponse: PlanDiscountUpdateReducer,

  ManualCreditGrantData: ManualCreditGrantReducer,

  EntityTransactionsData: EntityTransactionsReducer,

  BadgeListData: BadgeListReducer,
  BadgeCreateData: BadgeCreateReducer,
  BadgeUpdateData: BadgeUpdateReducer,
  BadgeDeleteData: BadgeDeleteReducer,

  CertificateListData: CertificateListReducer,
  CertificateCreateData: CertificateCreateReducer,
  CertificateUpdateData: CertificateUpdateReducer,
  CertificateDeleteData: CertificateDeleteReducer,
  CertificateTemplateUploadData: CertificateTemplateUploadReducer,

  CertificateCriteriaListData: CertificateCriteriaListReducer,
  CertificateCriteriaByIdData: CertificateCriteriaByIdReducer,
  CertificateCriteriaCreateData: CertificateCriteriaCreateReducer,
  CertificateCriteriaUpdateData: CertificateCriteriaUpdateReducer,
  CertificateCriteriaDeleteData: CertificateCriteriaDeleteReducer,

  getPresignedUrl: GetPresignedUrlReducer,
  uploadFile: UploadFileReducer,
  deleteFile: DeleteFileReducer,

  //Question Verify
  QuestionListState: QuestionListReducer,
  QuestionDetailsState: QuestionDetailsReducer,
  QuestionVerifyState: QuestionVerifyReducer,
  ExtractQuestionPdfState: ExtractQuestionPdfReducer,
  BulkCreateMCQState: BulkCreateMCQReducer,

  // SBW-2273 pricing admin
  FeatureCatalogListData: FeatureCatalogListReducer,
  FeatureCatalogMutationData: FeatureCatalogMutationReducer,
  CalculatorPresetListData: CalculatorPresetListReducer,
  CalculatorPresetMutationData: CalculatorPresetMutationReducer,
  TopupPresetListData: TopupPresetListReducer,
  TopupPresetMutationData: TopupPresetMutationReducer,
  TopupBonusRuleListData: TopupBonusRuleListReducer,
  TopupBonusRuleMutationData: TopupBonusRuleMutationReducer,
  CurrencyCreditRateListData: CurrencyCreditRateListReducer,
  CurrencyCreditRateMutationData: CurrencyCreditRateMutationReducer,
  ChargeSyncPreviewData: ChargeSyncPreviewReducer,
  ChargeSyncApplyData: ChargeSyncApplyReducer,
});

let initialState = {};
const middleware = [thunk];
const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);
export default store;
